/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarCargoDto,
  CargoResponse,
  CargosControllerListarParams,
  CatalogoDePermissoesResponse,
  CriarCargoDto,
  DefinirPermissoesDto,
  ErroResponse,
  PaginaDeCargosResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCargosControllerListarUrl = (params?: CargosControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/cargos?${stringifiedParams}` : `/v1/admin/cargos`
}

/**
 * @summary Lista os cargos, paginado
 */
export const cargosControllerListar = async (params?: CargosControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeCargosResponse> => {

  return httpClient<PaginaDeCargosResponse>(getCargosControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCargosControllerListarQueryKey = (params?: CargosControllerListarParams,) => {
    return [
    `/v1/admin/cargos`, ...(params ? [params] : [])
    ] as const;
    }


export const getCargosControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof cargosControllerListar>>, TError = ErroResponse>(params?: CargosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCargosControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cargosControllerListar>>> = ({ signal }) => cargosControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cargosControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CargosControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof cargosControllerListar>>>
export type CargosControllerListarQueryError = ErroResponse


export function useCargosControllerListar<TData = Awaited<ReturnType<typeof cargosControllerListar>>, TError = ErroResponse>(
 params: undefined |  CargosControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cargosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof cargosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCargosControllerListar<TData = Awaited<ReturnType<typeof cargosControllerListar>>, TError = ErroResponse>(
 params?: CargosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cargosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof cargosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCargosControllerListar<TData = Awaited<ReturnType<typeof cargosControllerListar>>, TError = ErroResponse>(
 params?: CargosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os cargos, paginado
 */

export function useCargosControllerListar<TData = Awaited<ReturnType<typeof cargosControllerListar>>, TError = ErroResponse>(
 params?: CargosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCargosControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCargosControllerCriarUrl = () => {




  return `/v1/admin/cargos`
}

/**
 * @summary Cria um cargo. A chave é derivada do nome e é imutável.
 */
export const cargosControllerCriar = async (criarCargoDto: CriarCargoDto, options?: Parameters<typeof httpClient>[1]): Promise<CargoResponse> => {

  return httpClient<CargoResponse>(getCargosControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarCargoDto)
  }
);}





export const getCargosControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cargosControllerCriar>>, TError,{data: CriarCargoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cargosControllerCriar>>, TError,{data: CriarCargoDto}, TContext> => {

const mutationKey = ['cargosControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cargosControllerCriar>>, {data: CriarCargoDto}> = (props) => {
          const {data} = props ?? {};

          return  cargosControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CargosControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof cargosControllerCriar>>>
    export type CargosControllerCriarMutationBody = CriarCargoDto
    export type CargosControllerCriarMutationError = ErroResponse

    /**
 * @summary Cria um cargo. A chave é derivada do nome e é imutável.
 */
export const useCargosControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cargosControllerCriar>>, TError,{data: CriarCargoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cargosControllerCriar>>,
        TError,
        {data: CriarCargoDto},
        TContext
      > => {
      return useMutation(getCargosControllerCriarMutationOptions(options), queryClient);
    }
    export const getCargosControllerCatalogoUrl = () => {




  return `/v1/admin/cargos/permissoes`
}

/**
 * @summary Catálogo de permissões agrupado por módulo
 */
export const cargosControllerCatalogo = async ( options?: Parameters<typeof httpClient>[1]): Promise<CatalogoDePermissoesResponse> => {

  return httpClient<CatalogoDePermissoesResponse>(getCargosControllerCatalogoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCargosControllerCatalogoQueryKey = () => {
    return [
    `/v1/admin/cargos/permissoes`
    ] as const;
    }


export const getCargosControllerCatalogoQueryOptions = <TData = Awaited<ReturnType<typeof cargosControllerCatalogo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerCatalogo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCargosControllerCatalogoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cargosControllerCatalogo>>> = ({ signal }) => cargosControllerCatalogo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cargosControllerCatalogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CargosControllerCatalogoQueryResult = NonNullable<Awaited<ReturnType<typeof cargosControllerCatalogo>>>
export type CargosControllerCatalogoQueryError = unknown


export function useCargosControllerCatalogo<TData = Awaited<ReturnType<typeof cargosControllerCatalogo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerCatalogo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cargosControllerCatalogo>>,
          TError,
          Awaited<ReturnType<typeof cargosControllerCatalogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCargosControllerCatalogo<TData = Awaited<ReturnType<typeof cargosControllerCatalogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerCatalogo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cargosControllerCatalogo>>,
          TError,
          Awaited<ReturnType<typeof cargosControllerCatalogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCargosControllerCatalogo<TData = Awaited<ReturnType<typeof cargosControllerCatalogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerCatalogo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Catálogo de permissões agrupado por módulo
 */

export function useCargosControllerCatalogo<TData = Awaited<ReturnType<typeof cargosControllerCatalogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerCatalogo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCargosControllerCatalogoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCargosControllerObterUrl = (id: string,) => {




  return `/v1/admin/cargos/${id}`
}

/**
 * @summary Detalha um cargo
 */
export const cargosControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<CargoResponse> => {

  return httpClient<CargoResponse>(getCargosControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCargosControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/admin/cargos/${id}`
    ] as const;
    }


export const getCargosControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof cargosControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCargosControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cargosControllerObter>>> = ({ signal }) => cargosControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cargosControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CargosControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof cargosControllerObter>>>
export type CargosControllerObterQueryError = ErroResponse


export function useCargosControllerObter<TData = Awaited<ReturnType<typeof cargosControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cargosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof cargosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCargosControllerObter<TData = Awaited<ReturnType<typeof cargosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cargosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof cargosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCargosControllerObter<TData = Awaited<ReturnType<typeof cargosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um cargo
 */

export function useCargosControllerObter<TData = Awaited<ReturnType<typeof cargosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cargosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCargosControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCargosControllerAtualizarUrl = (id: string,) => {




  return `/v1/admin/cargos/${id}`
}

/**
 * @summary Renomeia o cargo. A `chave` não muda.
 */
export const cargosControllerAtualizar = async (id: string,
    atualizarCargoDto: AtualizarCargoDto, options?: Parameters<typeof httpClient>[1]): Promise<CargoResponse> => {

  return httpClient<CargoResponse>(getCargosControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarCargoDto)
  }
);}





export const getCargosControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cargosControllerAtualizar>>, TError,{id: string;data: AtualizarCargoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cargosControllerAtualizar>>, TError,{id: string;data: AtualizarCargoDto}, TContext> => {

const mutationKey = ['cargosControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cargosControllerAtualizar>>, {id: string;data: AtualizarCargoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  cargosControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CargosControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof cargosControllerAtualizar>>>
    export type CargosControllerAtualizarMutationBody = AtualizarCargoDto
    export type CargosControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Renomeia o cargo. A `chave` não muda.
 */
export const useCargosControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cargosControllerAtualizar>>, TError,{id: string;data: AtualizarCargoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cargosControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarCargoDto},
        TContext
      > => {
      return useMutation(getCargosControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getCargosControllerExcluirUrl = (id: string,) => {




  return `/v1/admin/cargos/${id}`
}

/**
 * @summary Exclui um cargo. Recusa cargo de sistema ou com membros.
 */
export const cargosControllerExcluir = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getCargosControllerExcluirUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getCargosControllerExcluirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cargosControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cargosControllerExcluir>>, TError,{id: string}, TContext> => {

const mutationKey = ['cargosControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cargosControllerExcluir>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cargosControllerExcluir(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CargosControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof cargosControllerExcluir>>>

    export type CargosControllerExcluirMutationError = ErroResponse

    /**
 * @summary Exclui um cargo. Recusa cargo de sistema ou com membros.
 */
export const useCargosControllerExcluir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cargosControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cargosControllerExcluir>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCargosControllerExcluirMutationOptions(options), queryClient);
    }
    export const getCargosControllerDefinirPermissoesUrl = (id: string,) => {




  return `/v1/admin/cargos/${id}/permissoes`
}

/**
 * @summary Substitui o conjunto de permissões e invalida o cache
 */
export const cargosControllerDefinirPermissoes = async (id: string,
    definirPermissoesDto: DefinirPermissoesDto, options?: Parameters<typeof httpClient>[1]): Promise<CargoResponse> => {

  return httpClient<CargoResponse>(getCargosControllerDefinirPermissoesUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirPermissoesDto)
  }
);}





export const getCargosControllerDefinirPermissoesMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cargosControllerDefinirPermissoes>>, TError,{id: string;data: DefinirPermissoesDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cargosControllerDefinirPermissoes>>, TError,{id: string;data: DefinirPermissoesDto}, TContext> => {

const mutationKey = ['cargosControllerDefinirPermissoes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cargosControllerDefinirPermissoes>>, {id: string;data: DefinirPermissoesDto}> = (props) => {
          const {id,data} = props ?? {};

          return  cargosControllerDefinirPermissoes(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CargosControllerDefinirPermissoesMutationResult = NonNullable<Awaited<ReturnType<typeof cargosControllerDefinirPermissoes>>>
    export type CargosControllerDefinirPermissoesMutationBody = DefinirPermissoesDto
    export type CargosControllerDefinirPermissoesMutationError = ErroResponse

    /**
 * @summary Substitui o conjunto de permissões e invalida o cache
 */
export const useCargosControllerDefinirPermissoes = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cargosControllerDefinirPermissoes>>, TError,{id: string;data: DefinirPermissoesDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cargosControllerDefinirPermissoes>>,
        TError,
        {id: string;data: DefinirPermissoesDto},
        TContext
      > => {
      return useMutation(getCargosControllerDefinirPermissoesMutationOptions(options), queryClient);
    }
